// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__37NQT","containerItemsCenter":"Skeleton_containerItemsCenter__39ImP"};